import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getFundCreditByAgeChartKey = 'getFundCreditByAgeChartData';
export interface FundCreditByAgeChartState {
  loadFundCreditByAgeChartResponse: IDistributionChart[];
  loadFundCreditByAgeChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: FundCreditByAgeChartState = {
  loadFundCreditByAgeChartResponse: undefined,
  loadFundCreditByAgeChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadFundCreditByAgeChart, (state, action) => ({
    ...state
  })),
  on(actions.loadFundCreditByAgeChartSuccess, (state, action) => ({
    ...state,
    loadFundCreditByAgeChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadFundCreditByAgeChartFailure, (state, action) => ({
    ...state,
    loadFundCreditByAgeChartResponseFailure: action.error
  }))
);

export const getFundCreditByAgeChart = (state: FundCreditByAgeChartState) => {
  if (state && state.loadFundCreditByAgeChartResponse) return JSON.parse(JSON.stringify(state.loadFundCreditByAgeChartResponse));
  else return null;
};

export const getFundCreditByAgeChartIsLoaded = (state: FundCreditByAgeChartState) => {
  state.loaded;
};
